import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Info({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.6667 10.6471V15.6765H11.3333V10.6471H12.6667Z"
        fill={iconColor}
      />
      <Path
        d="M12.6667 8.66667V9.86274H11.3333V8.66667H12.6667Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.6667 12C18.6667 15.6819 15.6819 18.6667 12 18.6667C8.3181 18.6667 5.33333 15.6819 5.33333 12C5.33333 8.3181 8.3181 5.33333 12 5.33333C15.6819 5.33333 18.6667 8.3181 18.6667 12Z"
        fill={iconColor}
      />
    </Svg>
  );
}
